export default {
  patient: {
    firstName: 'Nama depan',
    lastName: 'Nama keluarga',
    medications: {
      label: 'Pengobatan',
      new: 'Tambahkan Obat Baru',
      warning: {
        noMedications: 'Tidak Ada Pengobatan',
      },
      noMedicationsMessage: 'Tidak ada permintaan obat untuk orang ini.',
    },
  },
}
